"use client";

import ImageText5050 from "@/components/ImageText5050/ImageText5050.component";
import { IntroTextWithVideos } from "@/components/IntroTextWithVideos/IntroTextWithVideos.component";
import LandingScreen from "@/components/LandingScreen/LandingScreen.component";
import Offices from "@/components/Offices/Offices.component";
import { ScrollingTextWithVideos } from "@/components/ScrollingTextWithVideos/ScrollingTextWithVideos.component";
import WorkShowcase from "@/components/WorkShowcase/WorkShowcase.component";
import { PageContextProvider } from "@/context/PageContext/PageContextProvider";
import {
  useContentfulInspectorMode,
  useContentfulLiveUpdates,
} from "@contentful/live-preview/react";
import { HomePageProps } from "./HomePage.model";

export default function HomePage({ data }: HomePageProps) {
  const inspectorProps = useContentfulInspectorMode({
    entryId: data?.page?.sys?.id,
  });
  const liveData = useContentfulLiveUpdates(data);

  const {
    page: {
      offices,
      heroLandingScreen,
      introText,
      workShowcaseCollection,
      imageText5050,
      scrollingText,
    },
  } = liveData;

  return (
    <PageContextProvider data={data}>
      <div className="home__section mb-[-1px] w-screen">
        {heroLandingScreen && (
          <div {...inspectorProps({ fieldId: "heroLandingScreen" })}>
            <LandingScreen {...heroLandingScreen} />
          </div>
        )}
        {introText && (
          <div {...inspectorProps({ fieldId: "introText" })}>
            <IntroTextWithVideos {...introText} />
          </div>
        )}
        {workShowcaseCollection && (
          <div {...inspectorProps({ fieldId: "workShowcase" })}>
            <WorkShowcase items={workShowcaseCollection} />
          </div>
        )}
        {imageText5050 && (
          <div {...inspectorProps({ fieldId: "imageText5050" })}>
            <ImageText5050 {...imageText5050} />
          </div>
        )}
        {offices && (
          <div {...inspectorProps({ fieldId: "offices" })}>
            <Offices {...offices} />
          </div>
        )}
        {scrollingText && (
          <div
            {...inspectorProps({ fieldId: "componentScrollingTextWithVideos" })}
          >
            <ScrollingTextWithVideos {...scrollingText} />
          </div>
        )}
      </div>
    </PageContextProvider>
  );
}
